import React from "react"
import PropTypes from "prop-types"

import SentConnectItem from './SentConnectItem'

class SentConnectRequests extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      responded: false
    }

    this.renderRequests = this.renderRequests.bind(this)
  }

  renderRequests() {
    return(this.props.requestedConnects.map((req, i) => {
      return (
        <SentConnectItem
          req={req}
          key={i}
        />
      )
    }))
  }

  render() {
    return(
      <div style={{marginTop:24, marginBottom: 24}}>
        <h4 className="sectionHeader" style={{marginBottom: 12, textAlign: 'left'}}>Sent Connect Requests</h4>
        <h4 className="sectionText" style={{marginBottom: 12}}>You are waiting for their response.</h4>
        {this.props.requestedConnects.length > 0 && this.renderRequests()}
      </div>
    )
  }

}

export default SentConnectRequests;
